import { ResourceType } from "@/services/cloudchipr.api";

export const offHoursAvailableResourceTypes: ResourceType[] = [
  "ec2",
  "rds",
  "vm",
  "sql",
  "az_vm",
];

export const offHoursAllActions = {
  notify: "Notify on Actions",
  silent: "Execute Actions Silently",
};
